export default "__VITE_ASSET__55b86022__"